
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class EmployeeSummaryItem extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: String, default: "" }) readonly hint!: string;
}
